import { masterAccountPermissionsFor, type MasterAccountPermission } from '@insio/shared-types';
import type { AuthUser } from '../context/AuthContext';

/** Whether the session acts in a master account (the master account board) rather than in an account. */
export function isMasterContext(user: Pick<AuthUser, 'currentMasterAccount'> | null | undefined) {
  return !!user?.currentMasterAccount;
}

/**
 * A predicate over the master permissions the caller's roles in the current master account grant;
 * always false outside master context.
 */
export function masterPermissionCheck(
  user: Pick<AuthUser, 'currentMasterAccount'> | null | undefined
): (permission: MasterAccountPermission) => boolean {
  const granted = new Set(masterAccountPermissionsFor(user?.currentMasterAccount?.roles ?? []));
  return permission => granted.has(permission);
}
